import { SearchMenuContext } from "./search-menu.context";
import type { SearchMenuProps } from "./types-search-menu";
import { useSearchMenu } from "./use-search-menu";
import { SearchMenuView } from "./view-search-menu";

export function SearchMenuRoot({ children, ...options }: SearchMenuProps) {
  const viewModel = useSearchMenu(options);

  return (
    <SearchMenuContext.Provider value={viewModel}>
      <SearchMenuView
        panel={viewModel.panel}
        appendTo={viewModel.appendTo}
        panelClassName={viewModel.panelClassName}
        onShow={viewModel.onShow}
        onHide={viewModel.onHide}
        testId={viewModel.testId}
        className={viewModel.className}
        style={viewModel.style}
        rest={viewModel.rest}
      >
        {children}
      </SearchMenuView>
    </SearchMenuContext.Provider>
  );
}
SearchMenuRoot.displayName = "SearchMenu.Root";
